import { n as ae, y as wa, d as q, k as hr, z as Da, _ as U, K as Na, T as xa, M as za, L as La, h as Qr, U as ia, R as va, O as Ta, v as $a, u as Wa } from "./CSSMotionList.js";
import { P as ba } from "./Portal.js";
import { R as Ma } from "./index5.js";
import { g as la } from "./reactNode.js";
import { u as Ba } from "./useId.js";
import * as i from "react";
import { _ as Ca } from "./extends.js";
import { i as Ha } from "./ContextIsolator.js";
const qa = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var r = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(r) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(r == null ? void 0 : r.substr(0, 4));
};
function Aa(r) {
  var t = r.prefixCls, e = r.align, a = r.arrow, o = r.arrowPos, s = a || {}, u = s.className, d = s.content, f = o.x, g = f === void 0 ? 0 : f, T = o.y, h = T === void 0 ? 0 : T, y = i.useRef();
  if (!e || !e.points)
    return null;
  var v = {
    position: "absolute"
  };
  if (e.autoArrow !== !1) {
    var k = e.points[0], z = e.points[1], D = k[0], $ = k[1], N = z[0], M = z[1];
    D === N || !["t", "b"].includes(D) ? v.top = h : D === "t" ? v.top = 0 : v.bottom = 0, $ === M || !["l", "r"].includes($) ? v.left = g : $ === "l" ? v.left = 0 : v.right = 0;
  }
  return /* @__PURE__ */ i.createElement("div", {
    ref: y,
    className: ae("".concat(t, "-arrow"), u),
    style: v
  }, d);
}
function Ra(r) {
  var t = r.prefixCls, e = r.open, a = r.zIndex, o = r.mask, s = r.motion;
  return o ? /* @__PURE__ */ i.createElement(wa, Ca({}, s, {
    motionAppear: !0,
    visible: e,
    removeOnLeave: !0
  }), function(u) {
    var d = u.className;
    return /* @__PURE__ */ i.createElement("div", {
      style: {
        zIndex: a
      },
      className: ae("".concat(t, "-mask"), d)
    });
  }) : null;
}
var Pa = /* @__PURE__ */ i.memo(function(r) {
  var t = r.children;
  return t;
}, function(r, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (Pa.displayName = "PopupContent");
var ka = /* @__PURE__ */ i.forwardRef(function(r, t) {
  var e = r.popup, a = r.className, o = r.prefixCls, s = r.style, u = r.target, d = r.onVisibleChanged, f = r.open, g = r.keepDom, T = r.fresh, h = r.onClick, y = r.mask, v = r.arrow, k = r.arrowPos, z = r.align, D = r.motion, $ = r.maskMotion, N = r.forceRender, M = r.getPopupContainer, W = r.autoDestroy, L = r.portal, c = r.zIndex, kr = r.onMouseEnter, Sr = r.onMouseLeave, mr = r.onPointerEnter, Dr = r.onPointerDownCapture, qr = r.ready, gr = r.offsetX, yr = r.offsetY, ir = r.offsetR, wr = r.offsetB, K = r.onAlign, br = r.onPrepare, A = r.stretch, E = r.targetWidth, m = r.targetHeight, Ar = typeof e == "function" ? e() : e, rr = f || g, R = (M == null ? void 0 : M.length) > 0, w = i.useState(!M || !R), Z = q(w, 2), Rr = Z[0], ne = Z[1];
  if (hr(function() {
    !Rr && R && u && ne(!0);
  }, [Rr, R, u]), !Rr)
    return null;
  var lr = "auto", G = {
    left: "-1000vw",
    top: "-1000vh",
    right: lr,
    bottom: lr
  };
  if (qr || !f) {
    var Nr, Er = z.points, Q = z.dynamicInset || ((Nr = z._experimental) === null || Nr === void 0 ? void 0 : Nr.dynamicInset), sr = Q && Er[0][1] === "r", er = Q && Er[0][0] === "b";
    sr ? (G.right = ir, G.left = lr) : (G.left = gr, G.right = lr), er ? (G.bottom = wr, G.top = lr) : (G.top = yr, G.bottom = lr);
  }
  var J = {};
  return A && (A.includes("height") && m ? J.height = m : A.includes("minHeight") && m && (J.minHeight = m), A.includes("width") && E ? J.width = E : A.includes("minWidth") && E && (J.minWidth = E)), f || (J.pointerEvents = "none"), /* @__PURE__ */ i.createElement(L, {
    open: N || rr,
    getContainer: M && function() {
      return M(u);
    },
    autoDestroy: W
  }, /* @__PURE__ */ i.createElement(Ra, {
    prefixCls: o,
    open: f,
    zIndex: c,
    mask: y,
    motion: $
  }), /* @__PURE__ */ i.createElement(Ma, {
    onResize: K,
    disabled: !f
  }, function(te) {
    return /* @__PURE__ */ i.createElement(wa, Ca({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: N,
      leavedClassName: "".concat(o, "-hidden")
    }, D, {
      onAppearPrepare: br,
      onEnterPrepare: br,
      visible: f,
      onVisibleChanged: function(_) {
        var ur;
        D == null || (ur = D.onVisibleChanged) === null || ur === void 0 || ur.call(D, _), d(_);
      }
    }), function(xr, _) {
      var ur = xr.className, Vr = xr.style, V = ae(o, ur, a);
      return /* @__PURE__ */ i.createElement("div", {
        ref: Da(te, t, _),
        className: V,
        style: U(U(U(U({
          "--arrow-x": "".concat(k.x || 0, "px"),
          "--arrow-y": "".concat(k.y || 0, "px")
        }, G), J), Vr), {}, {
          boxSizing: "border-box",
          zIndex: c
        }, s),
        onMouseEnter: kr,
        onMouseLeave: Sr,
        onPointerEnter: mr,
        onClick: h,
        onPointerDownCapture: Dr
      }, v && /* @__PURE__ */ i.createElement(Aa, {
        prefixCls: o,
        arrow: v,
        arrowPos: k,
        align: z
      }), /* @__PURE__ */ i.createElement(Pa, {
        cache: !f && !T
      }, Ar));
    });
  }));
});
process.env.NODE_ENV !== "production" && (ka.displayName = "Popup");
var Sa = /* @__PURE__ */ i.forwardRef(function(r, t) {
  var e = r.children, a = r.getTriggerDOMNode, o = Na(e), s = i.useCallback(function(d) {
    xa(t, a ? a(d) : d);
  }, [a]), u = za(s, La(e));
  return o ? /* @__PURE__ */ i.cloneElement(e, {
    ref: u
  }) : e;
});
process.env.NODE_ENV !== "production" && (Sa.displayName = "TriggerWrapper");
var ca = /* @__PURE__ */ i.createContext(null);
function da(r) {
  return r ? Array.isArray(r) ? r : [r] : [];
}
function Ea(r, t, e, a) {
  return i.useMemo(function() {
    var o = da(e ?? t), s = da(a ?? t), u = new Set(o), d = new Set(s);
    return r && (u.has("hover") && (u.delete("hover"), u.add("click")), d.has("hover") && (d.delete("hover"), d.add("click"))), [u, d];
  }, [r, t, e, a]);
}
function Va() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], e = arguments.length > 2 ? arguments[2] : void 0;
  return e ? r[0] === t[0] : r[0] === t[0] && r[1] === t[1];
}
function Fa(r, t, e, a) {
  for (var o = e.points, s = Object.keys(r), u = 0; u < s.length; u += 1) {
    var d, f = s[u];
    if (Va((d = r[f]) === null || d === void 0 ? void 0 : d.points, o, a))
      return "".concat(t, "-placement-").concat(f);
  }
  return "";
}
function fa(r, t, e, a) {
  return t || (e ? {
    motionName: "".concat(r, "-").concat(e)
  } : a ? {
    motionName: a
  } : null);
}
function me(r) {
  return r.ownerDocument.defaultView;
}
function sa(r) {
  for (var t = [], e = r == null ? void 0 : r.parentElement, a = ["hidden", "scroll", "clip", "auto"]; e; ) {
    var o = me(e).getComputedStyle(e), s = o.overflowX, u = o.overflowY, d = o.overflow;
    [s, u, d].some(function(f) {
      return a.includes(f);
    }) && t.push(e), e = e.parentElement;
  }
  return t;
}
function he(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(r) ? t : r;
}
function fe(r) {
  return he(parseFloat(r), 0);
}
function ha(r, t) {
  var e = U({}, r);
  return (t || []).forEach(function(a) {
    if (!(a instanceof HTMLBodyElement || a instanceof HTMLHtmlElement)) {
      var o = me(a).getComputedStyle(a), s = o.overflow, u = o.overflowClipMargin, d = o.borderTopWidth, f = o.borderBottomWidth, g = o.borderLeftWidth, T = o.borderRightWidth, h = a.getBoundingClientRect(), y = a.offsetHeight, v = a.clientHeight, k = a.offsetWidth, z = a.clientWidth, D = fe(d), $ = fe(f), N = fe(g), M = fe(T), W = he(Math.round(h.width / k * 1e3) / 1e3), L = he(Math.round(h.height / y * 1e3) / 1e3), c = (k - z - N - M) * W, kr = (y - v - D - $) * L, Sr = D * L, mr = $ * L, Dr = N * W, qr = M * W, gr = 0, yr = 0;
      if (s === "clip") {
        var ir = fe(u);
        gr = ir * W, yr = ir * L;
      }
      var wr = h.x + Dr - gr, K = h.y + Sr - yr, br = wr + h.width + 2 * gr - Dr - qr - c, A = K + h.height + 2 * yr - Sr - mr - kr;
      e.left = Math.max(e.left, wr), e.top = Math.max(e.top, K), e.right = Math.min(e.right, br), e.bottom = Math.min(e.bottom, A);
    }
  }), e;
}
function ma(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = "".concat(t), a = e.match(/^(.*)\%$/);
  return a ? r * (parseFloat(a[1]) / 100) : parseFloat(e);
}
function ga(r, t) {
  var e = t || [], a = q(e, 2), o = a[0], s = a[1];
  return [ma(r.width, o), ma(r.height, s)];
}
function ya() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [r[0], r[1]];
}
function ee(r, t) {
  var e = t[0], a = t[1], o, s;
  return e === "t" ? s = r.y : e === "b" ? s = r.y + r.height : s = r.y + r.height / 2, a === "l" ? o = r.x : a === "r" ? o = r.x + r.width : o = r.x + r.width / 2, {
    x: o,
    y: s
  };
}
function Hr(r, t) {
  var e = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return r.map(function(a, o) {
    return o === t ? e[a] || "c" : a;
  }).join("");
}
function ja(r, t, e, a, o, s, u) {
  var d = i.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: o[a] || {}
  }), f = q(d, 2), g = f[0], T = f[1], h = i.useRef(0), y = i.useMemo(function() {
    return t ? sa(t) : [];
  }, [t]), v = i.useRef({}), k = function() {
    v.current = {};
  };
  r || k();
  var z = Qr(function() {
    if (t && e && r) {
      let p = function(re, Wr) {
        var Br = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ge, de = w.x + re, Be = w.y + Wr, aa = de + sr, na = Be + Q, ta = Math.max(de, Br.left), n = Math.max(Be, Br.top), l = Math.min(aa, Br.right), S = Math.min(na, Br.bottom);
        return Math.max(0, (l - ta) * (S - n));
      }, We = function() {
        Jr = w.y + P, Kr = Jr + Q, Cr = w.x + b, Xr = Cr + sr;
      };
      var N, M, W, L, c = t, kr = c.ownerDocument, Sr = me(c), mr = Sr.getComputedStyle(c), Dr = mr.width, qr = mr.height, gr = mr.position, yr = c.style.left, ir = c.style.top, wr = c.style.right, K = c.style.bottom, br = c.style.overflow, A = U(U({}, o[a]), s), E = kr.createElement("div");
      (N = c.parentElement) === null || N === void 0 || N.appendChild(E), E.style.left = "".concat(c.offsetLeft, "px"), E.style.top = "".concat(c.offsetTop, "px"), E.style.position = gr, E.style.height = "".concat(c.offsetHeight, "px"), E.style.width = "".concat(c.offsetWidth, "px"), c.style.left = "0", c.style.top = "0", c.style.right = "auto", c.style.bottom = "auto", c.style.overflow = "hidden";
      var m;
      if (Array.isArray(e))
        m = {
          x: e[0],
          y: e[1],
          width: 0,
          height: 0
        };
      else {
        var Ar, rr, R = e.getBoundingClientRect();
        R.x = (Ar = R.x) !== null && Ar !== void 0 ? Ar : R.left, R.y = (rr = R.y) !== null && rr !== void 0 ? rr : R.top, m = {
          x: R.x,
          y: R.y,
          width: R.width,
          height: R.height
        };
      }
      var w = c.getBoundingClientRect();
      w.x = (M = w.x) !== null && M !== void 0 ? M : w.left, w.y = (W = w.y) !== null && W !== void 0 ? W : w.top;
      var Z = kr.documentElement, Rr = Z.clientWidth, ne = Z.clientHeight, lr = Z.scrollWidth, G = Z.scrollHeight, Nr = Z.scrollTop, Er = Z.scrollLeft, Q = w.height, sr = w.width, er = m.height, J = m.width, te = {
        left: 0,
        top: 0,
        right: Rr,
        bottom: ne
      }, xr = {
        left: -Er,
        top: -Nr,
        right: lr - Er,
        bottom: G - Nr
      }, _ = A.htmlRegion, ur = "visible", Vr = "visibleFirst";
      _ !== "scroll" && _ !== Vr && (_ = ur);
      var V = _ === Vr, Ae = ha(xr, y), C = ha(te, y), ge = _ === ur ? C : Ae, Fr = V ? C : ge;
      c.style.left = "auto", c.style.top = "auto", c.style.right = "0", c.style.bottom = "0";
      var F = c.getBoundingClientRect();
      c.style.left = yr, c.style.top = ir, c.style.right = wr, c.style.bottom = K, c.style.overflow = br, (L = c.parentElement) === null || L === void 0 || L.removeChild(E);
      var zr = he(Math.round(sr / parseFloat(Dr) * 1e3) / 1e3), Mr = he(Math.round(Q / parseFloat(qr) * 1e3) / 1e3);
      if (zr === 0 || Mr === 0 || ia(e) && !Ha(e))
        return;
      var Re = A.offset, Ee = A.targetOffset, ye = ga(w, Re), ar = q(ye, 2), nr = ar[0], X = ar[1], Ve = ga(m, Ee), jr = q(Ve, 2), Y = jr[0], Lr = jr[1];
      m.x -= Y, m.y -= Lr;
      var Fe = A.points || [], we = q(Fe, 2), je = we[0], Ue = we[1], vr = ya(Ue), I = ya(je), oe = ee(m, vr), j = ee(w, I), Tr = U({}, A), b = oe.x - j.x + nr, P = oe.y - j.y + X, tr = p(b, P), Ur = p(b, P, C), ie = ee(m, ["t", "l"]), O = ee(w, ["t", "l"]), be = ee(m, ["b", "r"]), le = ee(w, ["b", "r"]), $r = A.overflow || {}, Me = $r.adjustX, Je = $r.adjustY, se = $r.shiftX, _r = $r.shiftY, ue = function(Wr) {
        return typeof Wr == "boolean" ? Wr : Wr >= 0;
      }, Jr, Kr, Cr, Xr;
      We();
      var Zr = ue(Je), Ce = I[0] === vr[0];
      if (Zr && I[0] === "t" && (Kr > Fr.bottom || v.current.bt)) {
        var H = P;
        Ce ? H -= Q - er : H = ie.y - le.y - X;
        var Pe = p(b, H), Ke = p(b, H, C);
        // Of course use larger one
        Pe > tr || Pe === tr && (!V || // Choose recommend one
        Ke >= Ur) ? (v.current.bt = !0, P = H, X = -X, Tr.points = [Hr(I, 0), Hr(vr, 0)]) : v.current.bt = !1;
      }
      if (Zr && I[0] === "b" && (Jr < Fr.top || v.current.tb)) {
        var Gr = P;
        Ce ? Gr += Q - er : Gr = be.y - O.y - X;
        var ke = p(b, Gr), Ze = p(b, Gr, C);
        // Of course use larger one
        ke > tr || ke === tr && (!V || // Choose recommend one
        Ze >= Ur) ? (v.current.tb = !0, P = Gr, X = -X, Tr.points = [Hr(I, 0), Hr(vr, 0)]) : v.current.tb = !1;
      }
      var Se = ue(Me), De = I[1] === vr[1];
      if (Se && I[1] === "l" && (Xr > Fr.right || v.current.rl)) {
        var Ir = b;
        De ? Ir -= sr - J : Ir = ie.x - le.x - nr;
        var Ne = p(Ir, P), Yr = p(Ir, P, C);
        // Of course use larger one
        Ne > tr || Ne === tr && (!V || // Choose recommend one
        Yr >= Ur) ? (v.current.rl = !0, b = Ir, nr = -nr, Tr.points = [Hr(I, 1), Hr(vr, 1)]) : v.current.rl = !1;
      }
      if (Se && I[1] === "r" && (Cr < Fr.left || v.current.lr)) {
        var Pr = b;
        De ? Pr += sr - J : Pr = be.x - O.x - nr;
        var xe = p(Pr, P), ze = p(Pr, P, C);
        // Of course use larger one
        xe > tr || xe === tr && (!V || // Choose recommend one
        ze >= Ur) ? (v.current.lr = !0, b = Pr, nr = -nr, Tr.points = [Hr(I, 1), Hr(vr, 1)]) : v.current.lr = !1;
      }
      We();
      var cr = se === !0 ? 0 : se;
      typeof cr == "number" && (Cr < C.left && (b -= Cr - C.left - nr, m.x + J < C.left + cr && (b += m.x - C.left + J - cr)), Xr > C.right && (b -= Xr - C.right - nr, m.x > C.right - cr && (b += m.x - C.right + cr)));
      var or = _r === !0 ? 0 : _r;
      typeof or == "number" && (Jr < C.top && (P -= Jr - C.top - X, m.y + er < C.top + or && (P += m.y - C.top + er - or)), Kr > C.bottom && (P -= Kr - C.bottom - X, m.y > C.bottom - or && (P += m.y - C.bottom + or)));
      var Or = w.x + b, pr = Or + sr, dr = w.y + P, Ge = dr + Q, Le = m.x, Ie = Le + J, ve = m.y, Qe = ve + er, _e = Math.max(Or, Le), Xe = Math.min(pr, Ie), Te = (_e + Xe) / 2, Ye = Te - Or, Oe = Math.max(dr, ve), $e = Math.min(Ge, Qe), pe = (Oe + $e) / 2, ra = pe - dr;
      u == null || u(t, Tr);
      var ce = F.right - w.x - (b + w.width), fr = F.bottom - w.y - (P + w.height);
      zr === 1 && (b = Math.round(b), ce = Math.round(ce)), Mr === 1 && (P = Math.round(P), fr = Math.round(fr));
      var ea = {
        ready: !0,
        offsetX: b / zr,
        offsetY: P / Mr,
        offsetR: ce / zr,
        offsetB: fr / Mr,
        arrowX: Ye / zr,
        arrowY: ra / Mr,
        scaleX: zr,
        scaleY: Mr,
        align: Tr
      };
      T(ea);
    }
  }), D = function() {
    h.current += 1;
    var M = h.current;
    Promise.resolve().then(function() {
      h.current === M && z();
    });
  }, $ = function() {
    T(function(M) {
      return U(U({}, M), {}, {
        ready: !1
      });
    });
  };
  return hr($, [a]), hr(function() {
    r || $();
  }, [r]), [g.ready, g.offsetX, g.offsetY, g.offsetR, g.offsetB, g.arrowX, g.arrowY, g.scaleX, g.scaleY, g.align, D];
}
function Ua(r, t, e, a, o) {
  hr(function() {
    if (r && t && e) {
      let h = function() {
        a(), o();
      };
      var s = t, u = e, d = sa(s), f = sa(u), g = me(u), T = new Set([g].concat(va(d), va(f)));
      return T.forEach(function(y) {
        y.addEventListener("scroll", h, {
          passive: !0
        });
      }), g.addEventListener("resize", h, {
        passive: !0
      }), a(), function() {
        T.forEach(function(y) {
          y.removeEventListener("scroll", h), g.removeEventListener("resize", h);
        });
      };
    }
  }, [r, t, e]);
}
function Ja(r, t, e, a, o, s, u, d) {
  var f = i.useRef(r);
  f.current = r;
  var g = i.useRef(!1);
  i.useEffect(function() {
    if (t && a && (!o || s)) {
      var h = function() {
        g.current = !1;
      }, y = function(W) {
        var L;
        f.current && !u(((L = W.composedPath) === null || L === void 0 || (L = L.call(W)) === null || L === void 0 ? void 0 : L[0]) || W.target) && !g.current && d(!1);
      }, v = me(a);
      v.addEventListener("pointerdown", h, !0), v.addEventListener("mousedown", y, !0), v.addEventListener("contextmenu", y, !0);
      var k = la(e);
      if (k && (k.addEventListener("mousedown", y, !0), k.addEventListener("contextmenu", y, !0)), process.env.NODE_ENV !== "production") {
        var z, D, $ = e == null || (z = e.getRootNode) === null || z === void 0 ? void 0 : z.call(e), N = (D = a.getRootNode) === null || D === void 0 ? void 0 : D.call(a);
        Ta($ === N, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        v.removeEventListener("pointerdown", h, !0), v.removeEventListener("mousedown", y, !0), v.removeEventListener("contextmenu", y, !0), k && (k.removeEventListener("mousedown", y, !0), k.removeEventListener("contextmenu", y, !0));
      };
    }
  }, [t, e, a, o, s]);
  function T() {
    g.current = !0;
  }
  return T;
}
var Ka = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function Za() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ba, t = /* @__PURE__ */ i.forwardRef(function(e, a) {
    var o = e.prefixCls, s = o === void 0 ? "rc-trigger-popup" : o, u = e.children, d = e.action, f = d === void 0 ? "hover" : d, g = e.showAction, T = e.hideAction, h = e.popupVisible, y = e.defaultPopupVisible, v = e.onPopupVisibleChange, k = e.afterPopupVisibleChange, z = e.mouseEnterDelay, D = e.mouseLeaveDelay, $ = D === void 0 ? 0.1 : D, N = e.focusDelay, M = e.blurDelay, W = e.mask, L = e.maskClosable, c = L === void 0 ? !0 : L, kr = e.getPopupContainer, Sr = e.forceRender, mr = e.autoDestroy, Dr = e.destroyPopupOnHide, qr = e.popup, gr = e.popupClassName, yr = e.popupStyle, ir = e.popupPlacement, wr = e.builtinPlacements, K = wr === void 0 ? {} : wr, br = e.popupAlign, A = e.zIndex, E = e.stretch, m = e.getPopupClassNameFromAlign, Ar = e.fresh, rr = e.alignPoint, R = e.onPopupClick, w = e.onPopupAlign, Z = e.arrow, Rr = e.popupMotion, ne = e.maskMotion, lr = e.popupTransitionName, G = e.popupAnimation, Nr = e.maskTransitionName, Er = e.maskAnimation, Q = e.className, sr = e.getTriggerDOMNode, er = $a(e, Ka), J = mr || Dr || !1, te = i.useState(!1), xr = q(te, 2), _ = xr[0], ur = xr[1];
    hr(function() {
      ur(qa());
    }, []);
    var Vr = i.useRef({}), V = i.useContext(ca), Ae = i.useMemo(function() {
      return {
        registerSubPopup: function(l, S) {
          Vr.current[l] = S, V == null || V.registerSubPopup(l, S);
        }
      };
    }, [V]), C = Ba(), ge = i.useState(null), Fr = q(ge, 2), F = Fr[0], zr = Fr[1], Mr = i.useRef(null), Re = Qr(function(n) {
      Mr.current = n, ia(n) && F !== n && zr(n), V == null || V.registerSubPopup(C, n);
    }), Ee = i.useState(null), ye = q(Ee, 2), ar = ye[0], nr = ye[1], X = i.useRef(null), Ve = Qr(function(n) {
      ia(n) && ar !== n && (nr(n), X.current = n);
    }), jr = i.Children.only(u), Y = (jr == null ? void 0 : jr.props) || {}, Lr = {}, Fe = Qr(function(n) {
      var l, S, B = ar;
      return (B == null ? void 0 : B.contains(n)) || ((l = la(B)) === null || l === void 0 ? void 0 : l.host) === n || n === B || (F == null ? void 0 : F.contains(n)) || ((S = la(F)) === null || S === void 0 ? void 0 : S.host) === n || n === F || Object.values(Vr.current).some(function(x) {
        return (x == null ? void 0 : x.contains(n)) || n === x;
      });
    }), we = fa(s, Rr, G, lr), je = fa(s, ne, Er, Nr), Ue = i.useState(y || !1), vr = q(Ue, 2), I = vr[0], oe = vr[1], j = h ?? I, Tr = Qr(function(n) {
      h === void 0 && oe(n);
    });
    hr(function() {
      oe(h || !1);
    }, [h]);
    var b = i.useRef(j);
    b.current = j;
    var P = i.useRef([]);
    P.current = [];
    var tr = Qr(function(n) {
      var l;
      Tr(n), ((l = P.current[P.current.length - 1]) !== null && l !== void 0 ? l : j) !== n && (P.current.push(n), v == null || v(n));
    }), Ur = i.useRef(), ie = function() {
      clearTimeout(Ur.current);
    }, O = function(l) {
      var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      ie(), S === 0 ? tr(l) : Ur.current = setTimeout(function() {
        tr(l);
      }, S * 1e3);
    };
    i.useEffect(function() {
      return ie;
    }, []);
    var be = i.useState(!1), le = q(be, 2), $r = le[0], Me = le[1];
    hr(function(n) {
      (!n || j) && Me(!0);
    }, [j]);
    var Je = i.useState(null), se = q(Je, 2), _r = se[0], ue = se[1], Jr = i.useState(null), Kr = q(Jr, 2), Cr = Kr[0], Xr = Kr[1], Zr = function(l) {
      Xr([l.clientX, l.clientY]);
    }, Ce = ja(j, F, rr && Cr !== null ? Cr : ar, ir, K, br, w), H = q(Ce, 11), Pe = H[0], Ke = H[1], Gr = H[2], ke = H[3], Ze = H[4], Se = H[5], De = H[6], Ir = H[7], Ne = H[8], Yr = H[9], Pr = H[10], xe = Ea(_, f, g, T), ze = q(xe, 2), cr = ze[0], or = ze[1], Or = cr.has("click"), pr = or.has("click") || or.has("contextMenu"), dr = Qr(function() {
      $r || Pr();
    }), Ge = function() {
      b.current && rr && pr && O(!1);
    };
    Ua(j, ar, F, dr, Ge), hr(function() {
      dr();
    }, [Cr, ir]), hr(function() {
      j && !(K != null && K[ir]) && dr();
    }, [JSON.stringify(br)]);
    var Le = i.useMemo(function() {
      var n = Fa(K, s, Yr, rr);
      return ae(n, m == null ? void 0 : m(Yr));
    }, [Yr, m, K, s, rr]);
    i.useImperativeHandle(a, function() {
      return {
        nativeElement: X.current,
        popupElement: Mr.current,
        forceAlign: dr
      };
    });
    var Ie = i.useState(0), ve = q(Ie, 2), Qe = ve[0], _e = ve[1], Xe = i.useState(0), Te = q(Xe, 2), Ye = Te[0], Oe = Te[1], $e = function() {
      if (E && ar) {
        var l = ar.getBoundingClientRect();
        _e(l.width), Oe(l.height);
      }
    }, pe = function() {
      $e(), dr();
    }, ra = function(l) {
      Me(!1), Pr(), k == null || k(l);
    }, ce = function() {
      return new Promise(function(l) {
        $e(), ue(function() {
          return l;
        });
      });
    };
    hr(function() {
      _r && (Pr(), _r(), ue(null));
    }, [_r]);
    function fr(n, l, S, B) {
      Lr[n] = function(x) {
        var He;
        B == null || B(x), O(l, S);
        for (var oa = arguments.length, ua = new Array(oa > 1 ? oa - 1 : 0), qe = 1; qe < oa; qe++)
          ua[qe - 1] = arguments[qe];
        (He = Y[n]) === null || He === void 0 || He.call.apply(He, [Y, x].concat(ua));
      };
    }
    (Or || pr) && (Lr.onClick = function(n) {
      var l;
      b.current && pr ? O(!1) : !b.current && Or && (Zr(n), O(!0));
      for (var S = arguments.length, B = new Array(S > 1 ? S - 1 : 0), x = 1; x < S; x++)
        B[x - 1] = arguments[x];
      (l = Y.onClick) === null || l === void 0 || l.call.apply(l, [Y, n].concat(B));
    });
    var ea = Ja(j, pr, ar, F, W, c, Fe, O), p = cr.has("hover"), We = or.has("hover"), re, Wr;
    p && (fr("onMouseEnter", !0, z, function(n) {
      Zr(n);
    }), fr("onPointerEnter", !0, z, function(n) {
      Zr(n);
    }), re = function(l) {
      (j || $r) && F !== null && F !== void 0 && F.contains(l.target) && O(!0, z);
    }, rr && (Lr.onMouseMove = function(n) {
      var l;
      (l = Y.onMouseMove) === null || l === void 0 || l.call(Y, n);
    })), We && (fr("onMouseLeave", !1, $), fr("onPointerLeave", !1, $), Wr = function() {
      O(!1, $);
    }), cr.has("focus") && fr("onFocus", !0, N), or.has("focus") && fr("onBlur", !1, M), cr.has("contextMenu") && (Lr.onContextMenu = function(n) {
      var l;
      b.current && or.has("contextMenu") ? O(!1) : (Zr(n), O(!0)), n.preventDefault();
      for (var S = arguments.length, B = new Array(S > 1 ? S - 1 : 0), x = 1; x < S; x++)
        B[x - 1] = arguments[x];
      (l = Y.onContextMenu) === null || l === void 0 || l.call.apply(l, [Y, n].concat(B));
    }), Q && (Lr.className = ae(Y.className, Q));
    var Br = U(U({}, Y), Lr), de = {}, Be = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    Be.forEach(function(n) {
      er[n] && (de[n] = function() {
        for (var l, S = arguments.length, B = new Array(S), x = 0; x < S; x++)
          B[x] = arguments[x];
        (l = Br[n]) === null || l === void 0 || l.call.apply(l, [Br].concat(B)), er[n].apply(er, B);
      });
    });
    var aa = /* @__PURE__ */ i.cloneElement(jr, U(U({}, Br), de)), na = {
      x: Se,
      y: De
    }, ta = Z ? U({}, Z !== !0 ? Z : {}) : null;
    return /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(Ma, {
      disabled: !j,
      ref: Ve,
      onResize: pe
    }, /* @__PURE__ */ i.createElement(Sa, {
      getTriggerDOMNode: sr
    }, aa)), /* @__PURE__ */ i.createElement(ca.Provider, {
      value: Ae
    }, /* @__PURE__ */ i.createElement(ka, {
      portal: r,
      ref: Re,
      prefixCls: s,
      popup: qr,
      className: ae(gr, Le),
      style: yr,
      target: ar,
      onMouseEnter: re,
      onMouseLeave: Wr,
      onPointerEnter: re,
      zIndex: A,
      open: j,
      keepDom: $r,
      fresh: Ar,
      onClick: R,
      onPointerDownCapture: ea,
      mask: W,
      motion: we,
      maskMotion: je,
      onVisibleChanged: ra,
      onPrepare: ce,
      forceRender: Sr,
      autoDestroy: J,
      getPopupContainer: kr,
      align: Yr,
      arrow: ta,
      arrowPos: na,
      ready: Pe,
      offsetX: Ke,
      offsetY: Gr,
      offsetR: ke,
      offsetB: Ze,
      onAlign: dr,
      stretch: E,
      targetWidth: Qe / Ir,
      targetHeight: Ye / Ne
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const pa = Za(ba);
function rn(r) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: e,
    borderRadiusOuter: a
  } = r, o = t / 2, s = 0, u = o, d = a * 1 / Math.sqrt(2), f = o - a * (1 - 1 / Math.sqrt(2)), g = o - e * (1 / Math.sqrt(2)), T = a * (Math.sqrt(2) - 1) + e * (1 / Math.sqrt(2)), h = 2 * o - g, y = T, v = 2 * o - d, k = f, z = 2 * o - s, D = u, $ = o * Math.sqrt(2) + a * (Math.sqrt(2) - 2), N = a * (Math.sqrt(2) - 1), M = `polygon(${N}px 100%, 50% ${N}px, ${2 * o - N}px 100%, ${N}px 100%)`, W = `path('M ${s} ${u} A ${a} ${a} 0 0 0 ${d} ${f} L ${g} ${T} A ${e} ${e} 0 0 1 ${h} ${y} L ${v} ${k} A ${a} ${a} 0 0 0 ${z} ${D} Z')`;
  return {
    arrowShadowWidth: $,
    arrowPath: W,
    arrowPolygon: M
  };
}
const en = (r, t, e) => {
  const {
    sizePopupArrow: a,
    arrowPolygon: o,
    arrowPath: s,
    arrowShadowWidth: u,
    borderRadiusXS: d,
    calc: f
  } = r;
  return {
    pointerEvents: "none",
    width: a,
    height: a,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: a,
      height: f(a).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [o, s]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: u,
      height: u,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${Wa(d)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: e,
      zIndex: 0,
      background: "transparent"
    }
  };
};
export {
  pa as T,
  rn as a,
  en as g,
  qa as i
};
